import classNames from "classnames";
import AppContext from "PFApp/app_context";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import React, { useContext } from "react";

import EngagementProgress from "./engagement_progress";
import EngagementsHeader from "./engagements_header";
import css from "./engagements_progress_view.module.scss";

const EngagementsProgressView = () => {
  const {
    store: {
      pages: {
        workflowPage: {
          engagements: {
            data: { entries, meta, loading },
            fetchData
          }
        }
      }
    }
  } = useContext(AppContext);

  const handlePaginationClick = (number) => {
    fetchData({ page: number });
  };

  return (
    <div>
      <EngagementsHeader className={css.header} />
      <div className={classNames(css.wrapper, { [css.loading]: loading })}>
        {entries.map((item) => (
          <EngagementProgress key={item.id} item={item.activity} />
        ))}
      </div>

      <SimplePagination
        currentPage={meta.page}
        handleClick={handlePaginationClick}
        totalPages={meta.totalPages}
      />
    </div>
  );
};

export default EngagementsProgressView;
